import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import task from '../../../../assets/icons/task.svg';
import reminder from '../../../../assets/icons/reminder.svg';
import event from '../../../../assets/icons/event.svg';
import exit from '../../../../assets/icons/exit.svg';

import './Fab.css';

export default class Fab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: [
        { name: 'task', link: '/task', title: 'وظیفه', icon: task },
        { name: 'event', link: '/event', title: 'رویداد', icon: event },
        { name: 'reminder', link: '/reminder', title: 'یادآوری', icon: reminder },
      ],
    }
  }
  render() {
    return (
      <div className="mobile-fab d-flex flex-column">
        <div className="mobile-fab__top" onClick={() => this.props.setOpenFab()}></div>
        <div className="mobile-fab__bottom d-flex">
          <div className="mobile-fab__bottom--right" onClick={() => this.props.setOpenFab()}>
          </div>
          <div className="mobile-fab__bottom--left">
            <div className="mobile-fab__links d-flex flex-column">
              {
                this.state.actions.map(item => (
                  <Link to={item.link} key={item.name} className="d-flex fadeAnimation">
                    <div>{item.title}</div>
                    <div className="mobile-fab__links--circle d-flex">
                      <img src={item.icon} />
                    </div>
                  </Link>
                ))
              }
            </div>
            <div className="mobile-fab__back d-flex" onClick={() => this.props.setOpenFab()}>
              <img src={exit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}